import(/* webpackMode: "eager", webpackExports: ["NotFoundDesktop"] */ "/home/app/client/pb-front/src/app/[locale]/not-found/desktop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotFoundMobile"] */ "/home/app/client/pb-front/src/app/[locale]/not-found/mobile.tsx");
